export default __webpack_public_path__ + "static/media/om.baea54bc.svg";